import { Avatar, theme } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useState } from 'react';
import ProfileDialog from '../pages/login/profile_dialog';

const { useToken } = theme;

export default function ShellActionButtons() {
    const { token } = useToken();
    const [profileDialogOpen, setProfileDialogOpen] = useState(false);

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: token.marginSM }}>
                {/* Profile Avatar Button */}
                <Avatar
                    size={40}
                    icon={<UserOutlined />}
                    onClick={() => setProfileDialogOpen(true)}
                    style={{
                        cursor: 'pointer',
                    }}
                />
            </div>

            {/* Profile Dialog */}
            <ProfileDialog
                open={profileDialogOpen}
                onClose={() => setProfileDialogOpen(false)}
            />
        </>
    );
}